import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

const SlideBackgroundGradient = () => {
  return (
    <Box
      className={twJoin(
        'absolute bottom-0 left-0 h-[244px] w-full px-6 pb-6 pt-[100px]',
        'bg-gradient-to-t from-black/95 to-transparent'
      )}
    />
  );
};

export default SlideBackgroundGradient;
